import { Checkbox2 } from "components/Checkbox2/Checkbox2";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { Paragraph } from "components/Paragraph/Paragraph";

type NamedCheckboxProps = {
  name?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
};

export const NamedCheckbox = (props: NamedCheckboxProps): JSX.Element => {
  const { name, checked = false, onChange } = props;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    if (onChange) {
      onChange(isChecked);
    }
  };

  return (
    <div className="flex items-center">
      <Checkbox2 checked={checked} onChange={handleCheckboxChange} />
      <HorizontalSpace size={12} />
      {name && <Paragraph>{name}</Paragraph>}
    </div>
  );
};
